<template>
  <div>
    <div v-if="validata == 'success'" class="contract" v-loading="loading">
      <div style="height: calc(100vh - 72px);overflow-y: auto;">
        <div style="display: grid;grid-template-columns: 1fr;gap: 20px;padding:20px;align-items: flex-start;">

          <div style="border: 1px solid #ededed;padding:20px;border-radius: 20px;" v-loading="upload_loading_one">
            <div style="display: flex;justify-content: space-between;align-items: flex-start;">
              <p style="font-weight: bold;">업무위탁계약서<span style="color: red;margin-left: 10px;">*</span></p>

            </div>
            <div>
              <el-upload
                :action="uploadAction"
                :multiple="false"
                :show-file-list="false"
                :data="uploadData"
                :drag="true"
                :on-success="(res, file, fileList) => upload_file_success(res, file, fileList, 'type1')"
                :on-error="(res, file, fileList) => upload_file_error(res, file, fileList, 'type1')"
                :before-upload="(file) => beforeAvatarUpload(file, 'type1')"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">파일을 여기로 드래그하세요.</div>
                  <div class="el-upload__text"><em>업로드 클릭</em></div>
              </el-upload>
            </div>
            <div v-if="type_one_datas.length > 0">
                <div style="display: flex;justify-content: space-between;margin-top: 16px;color: gray;font-size: 14px;" v-for="item,index in type_one_datas" :key="index">
                  <span style="word-wrap: break-word;word-break: break-all;">{{item.fileName}}</span>
                  <i class="el-icon-delete" style="font-size: 16px;flex-shrink: 0;margin-left: 10px;color: #000000;" @click="deleteFile('type1', index)"/>
                </div>
            </div>
            <div style="margin-top: 25px;color: #999999;font-size: 12px;">힌트 : 업무위탁계약서 or 근로계약서</div>
          </div>

          <div style="border: 1px solid #ededed;padding:20px;border-radius: 20px;"  v-loading="upload_loading_two">
            <div style="display: flex;justify-content: space-between;align-items: flex-start;">
              <p style="font-weight: bold;">급여 내역 1년치<span style="color: red;margin-left: 10px;">*</span></p>

            </div>
            <div>
              <el-upload
                :action="uploadAction"
                :multiple="false"
                :show-file-list="false"
                :data="uploadData"
                :drag="true"
                :on-success="(res, file, fileList) => upload_file_success(res, file, fileList, 'type2')"
                :on-error="(res, file, fileList) => upload_file_error(res, file, fileList, 'type2')"
                :before-upload="(file) => beforeAvatarUpload(file, 'type2')"
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">파일을 여기로 드래그하세요.</div>
                <div class="el-upload__text"><em>업로드 클릭</em></div>
              </el-upload>
            </div>
            <div v-if="type_two_datas.length > 0">
                <div style="display: flex;justify-content: space-between;margin-top: 16px;color: gray;font-size: 14px;"
                 v-for="item,index in type_two_datas" :key="index">
                   <span style="word-wrap: break-word;word-break: break-all;">{{item.fileName}}</span>
                  <i class="el-icon-delete" style="font-size: 16px;flex-shrink: 0;margin-left: 10px;color: #000000;" @click="deleteFile('type2', index)"/>
                </div>
            </div>
            <div style="margin-top: 25px;color: #999999;font-size: 12px;">힌트 : 급여 내역 1년치 (임금명세서 or 통장입금 내역 등 증빙가능한 서류 일괄)</div>
          </div>

          <div style="border: 1px solid #ededed;padding:20px;border-radius: 20px;" v-loading="upload_loading_three">
            <div style="display: flex;justify-content: space-between;align-items: flex-start;">
              <p style="font-weight: bold;">근무 증빙</p>

            </div>
            <div>
              <el-upload
                :action="uploadAction"
                :multiple="false"
                :show-file-list="false"
                :data="uploadData"
                :drag="true"
                :on-success="(res, file, fileList) => upload_file_success(res, file, fileList, 'type3')"
                :on-error="(res, file, fileList) => upload_file_error(res, file, fileList, 'type3')"
                :before-upload="(file) => beforeAvatarUpload(file, 'type3')"
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">파일을 여기로 드래그하세요.</div>
                <div class="el-upload__text"><em>업로드 클릭</em></div>
              </el-upload>
            </div>
            <div v-if="type_three_datas.length > 0">
                <div style="display: flex;justify-content: space-between;margin-top: 16px;color: gray;font-size: 14px;"
                 v-for="item,index in type_three_datas" :key="index">
                   <span style="word-wrap: break-word;word-break: break-all;">{{item.fileName}}</span>
                  <i class="el-icon-delete" style="font-size: 16px;flex-shrink: 0;margin-left: 10px;color: #000000;" @click="deleteFile('type3', index)"/>
                </div>
            </div>
            <div style="margin-top: 25px;color: #999999;font-size: 12px;">
              힌트 :</br>
            - 출근부 등 출퇴근을 알 수 있는 서류</br>
            - 원장님 지시 사항 등이 담긴 문자, 톡 등 대화내용</br>
            - 근무표</br>
            - 월별 정산 내역 등</br>
            </div>
          </div>

        </div>
      </div>
      <div class="btn btnAct" @click="saveFile">제출</div>
    </div>


    <div v-if="validata == 'validata'" class="validata">
      <div id="home">
        <h1>안전한 자료 업로드를 위해 카카오 계정에 등록된 휴대폰 번호를 입력해 주세요</h1>
        <p>휴대폰 번호</p>
        <el-input
          :class="errInput !== ''?'errInput':''"
          style="width: 100%;margin-top: 10px;"
          v-model="phone"
          :editable="false"
          :clearable="false"
          @input="phoneInput"
          maxlength="13"
          type="tel">
        </el-input>
        <div class="error" v-if="errInput !== ''">
          <i class="el-icon-warning"></i>
          {{errInput}}
        </div>
        <div class="btn" :class="{btnAct:validatePhone}" @click="phoneValidate" v-loading="check_loading">
          검증
        </div>
      </div>
    </div>

    <div v-if="validata == 'upload_success'" style="margin-top: 100px;">
      <el-result icon="success" title="제출 성공" subTitle="자료 제출 감사합니다. 검토 후 빠르게 회신드리겠습니다.">
        <template slot="extra">
          <div style="background: #4873FF;color: #FFFFFF;display: flex;justify-content: center;margin-top: 30px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;"
           @click="go_home">
            처음으로
          </div>
        </template>
      </el-result>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  import { getAction, postAction } from '@/network/manage';
  export default {
    name: 'ContractFile',
    components: {
    },
    data() {
      return {
        validata: "validata",
        phone:'',
        errInput:'',
        loading:false,
        type_one_datas: [],
        type_two_datas: [],
        type_three_datas: [],
        uploadAction: process.env.VUE_APP_BASE_API + '/app/applicationRecord/uploadRecordFile',
        uploadData: {},
        uuid:'',
        upload_loading_one: false,
        upload_loading_two: false,
        upload_loading_three: false,
        check_loading: false
      }
    },
    computed: {
      validatePhone() {
        return /^01[016789]-\d{4}-\d{4}$/.test(this.phone)
      }
    },
    mounted() {
      this.uuid = this.$route.params.uuid

    },
    beforeDestroy() {

    },
    methods:{
      go_home() {
        this.$router.push('/home')
      },
      upload_file_error(res, file, filelist, type) {
        alert(res)
        if(type == 'type1') {
          this.upload_loading_one = false;
        } else if(type == 'type2') {
          this.upload_loading_two = false;
        } else if(type == 'type3') {
          this.upload_loading_three = false;
        }
      },
      upload_file_success(res, file, filelist, type) {
        let obj = {"fileName": res.result.name, "fileKey": res.result.fileKey}
        if(type == 'type1') {
          obj.type = "0"
          this.type_one_datas.push(obj);
          this.upload_loading_one = false;
        } else if(type == 'type2') {
          obj.type = "1"
          this.type_two_datas.push(obj);
          this.upload_loading_two = false;
        } else if(type == 'type3') {
          obj.type = "2"
          this.type_three_datas.push(obj);
          this.upload_loading_three = false;
        }
      },
      beforeAvatarUpload(file, type) {
        const isLt20M = file.size / 1024 / 1024 < 20;

        if (!isLt20M) {
          this.$message.error('파일 크기는 20MB를 초과할 수 없습니다!');
          return false;
        }

        const dangerousExtensions = [
            '.exe', '.com', '.bat', '.cmd', '.pif', '.scr', '.hta', '.cpl',
            '.msi', '.msp', '.mst', '.inf', '.reg', '.dll', '.sys',
            '.vbs', '.vbe', '.wsf', '.wsh', '.ps1', '.psm1', '.jar',
            '.js', '.jse', '.ws', '.wsc', '.scf', '.lnk', '.pif',
            '.html', '.htm', '.svg', '.xml'
        ];

        const fileName = file.name.toLowerCase();

        for (const ext of dangerousExtensions) {
          if (fileName.endsWith(ext)) {
              this.$message.error('정확한 자료 파일을 올려주세요.');
              return false;
          }
        }

        if(type == 'type1') {
          if(this.type_one_datas.length >= 20) {
            this.$message.error('최대 20개의 파일 업로드.');
            return false;
          }
          this.upload_loading_one = true
        } else if(type == 'type2') {
          if(this.type_two_datas.length >= 20) {
            this.$message.error('최대 20개의 파일 업로드.');
            return false;
          }
          this.upload_loading_two = true
        } else if(type == 'type3') {
          if(this.type_three_datas.length >= 20) {
            this.$message.error('최대 20개의 파일 업로드.');
            return false;
          }
          this.upload_loading_three = true
        }
        return true;
      },
      moment,
      deleteFile(type, index) {
        this.$confirm('삭제하시겠습니까?', '힌트', {
            confirmButtonText: '확정',
            cancelButtonText: '취소',
            type: 'warning'
          }).then(() => {
            if(type == 'type1') {
              this.type_one_datas.splice(index, 1);
            } else if(type == 'type2') {
              this.type_two_datas.splice(index, 1);
            } else if(type == 'type3') {
              this.type_three_datas.splice(index, 1);
            }
          }).catch(() => {

          });
      },
      phoneInput() {
        let value = this.phone;
        const digits = value.replace(/-/g, '')

        if (digits.length >= 4 && digits.length <= 7) {
          if (!value.startsWith(digits.slice(0, 3) + '-', 0)) {
            value = digits.slice(0, 3) + '-' + digits.slice(3)
          }
        }

        if (digits.length >= 8) {
          const firstPart = digits.slice(0, 3) + '-' + digits.slice(3, 7)
          if (!value.includes(firstPart + '-')) {
            value = firstPart + '-' + digits.slice(7, 11)
          }
        }
        this.phone = value
      },
      async phoneValidate() {
        if (!this.validatePhone) {
          this.errInput = '올바른 휴대폰 번호를 입력해주세요.'
          return
        }
        this.check_loading = true
        let result = await postAction("/app/applicationRecord/checkPhoneMatch/" + this.uuid, {phone: this.phone})
        this.check_loading = false
        if (result.success) {
          this.initDate()
        } else {
          this.errInput = '카카오 계정의 휴대폰 번호와 일치하지 않습니다.'
        }
      },
      async saveFile() {
        if(this.type_one_datas.length == 0) {
          this.$message.error('필수: 업무위탁계약서(or 근로계약서)');
          return false;
        }
        if(this.type_two_datas.length == 0) {
          this.$message.error('필수: 급여 입금 내역(최근 1년 치 통장 거래내역)');
          return false;
        }
        let array = [];
        for(let item of this.type_one_datas) {
          let target = {"fileName": item.fileName, "fileKey": item.fileKey, type: item.type};
          array.push(target);
        }
        for(let item of this.type_two_datas) {
          let target = {"fileName": item.fileName, "fileKey": item.fileKey, type: item.type};
          array.push(target);
        }
        for(let item of this.type_three_datas) {
          let target = {"fileName": item.fileName, "fileKey": item.fileKey, type: item.type};
          array.push(target);
        }
        this.loading = true;
        let res = await postAction("/app/applicationRecord/saveFileInfo/" + this.uuid, array);
        this.loading = false;
        if(res.code == 200) {
          this.validata = 'upload_success'
        }
      },
      async initDate(){
        this.validata = 'success'
        this.loading = true
        this.uploadData = {uuid: this.uuid, p: this.phone}
        const res = await getAction('/app/applicationRecord/getInfo/' + this.uuid)
        if(res.success && (res.result.state === 0
        || res.result.state === 1)) {
            const all_file_result = await getAction('/app/applicationRecord/getFileListInfo/' + this.uuid)
            for(let item of all_file_result.result) {
              if(item.type === "0") {
                this.type_one_datas.push(item)
              } else if(item.type === "1") {
                this.type_two_datas.push(item)
              } else if(item.type === "2") {
                this.type_three_datas.push(item)
              }
            }
            this.loading = false
        } else {
          this.$router.push('/home')
        }
      },
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  .validata #home{display: flex;flex-direction: column;width: 100%;padding:20px;overflow-y: auto;}
  .validata h1{color:#333333;font-size: 22px;margin:30px 0;}
  .validata p{color: #717B85;}
  .validata .btn{background:#EBECF0;color:#A8A8BC;display: flex;justify-content: center;margin-top:30px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .validata .btnAct{background:#4873FF !important;color:#ffffff !important;}
  .validata .status{display: flex;align-items: center;padding:40px;width: 100%;}
  .validata .status span{width: 30px;height: 30px;display: flex;flex-shrink: 0;margin:0 10px;justify-content: center;align-items: center;color:#717B85;font-weight: bold;background-color: #EBECF0;border-radius: 50%;}
  .validata .status .act{background-color: #C9D6FF;color: #003DFF;}
  .validata .status p{background-color: #EDEEF2;height: 1px;width: 100%;}
  .validata .errInput >>> .el-input__inner {background-color: #FFF3F3;border-color: #F20000;}
  .validata .error{display: flex;align-items: center;color: #EC0000;font-size: 14px;margin-top: 10px;}
  .validata .error i{margin-right: 5px;font-size: 18px;}
  .validata .xyDiv{background-color: rgba(0, 0, 0, 0.5);position: fixed;left:0;top:0;width: 100vw;height: 100vh;z-index: 10;display: flex;align-items: flex-end;}
  .validata .xyDiv .content{background-color: #ffffff;padding:20px;border-radius: 16px 16px 0 0;display: grid;grid-template-columns: 1fr;gap:30px;width: 100%;}
  .validata .xyDiv .content .header{display: flex;justify-content:space-between;}
  .validata .xyDiv .content .header i{font-size: 20px;}
  .validata .xyDiv .content h1{margin:0;font-size: 20px;}
  .validata .xyDiv .content .list{display: grid;grid-template-columns: 1fr;gap:20px;}
  .validata .xyDiv .content .list .item{color: #717B85;font-size: 14px;display: flex;align-items: center;}
  .validata .xyDiv .content .list .item i{font-size: 24px;margin-right: 6px;}
  .validata .xyDiv .btnConfirm{background:#EBECF0;color:#A8A8BC;display: flex;bottom:20px;justify-content: center;align-items: center;width:100%;height: 52px;border-radius: 26px;font-weight: bold;}

  .contract #home{height: 100vh;display: grid;width: 100%;grid-template-columns: 1fr;gap: 20px;grid-template-rows: auto auto 1fr;}
  .contract h1{color:#333333;font-size: 22px;margin:30px 20px 10px 20px;}
  .contract .btn{background:#EBECF0;color:#A8A8BC;display: flex;justify-content: center;margin:10px 20px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .contract .btnAct{background:#4873FF !important;color:#ffffff !important;}
  .contract .info{display: grid;grid-template-columns: 1fr;gap: 10px;margin:0 20px;}
  .contract .info .item{display: flex;justify-content: space-between;align-items: center;}
  .contract .info .item div{display: flex;flex-direction: column;width: 100%;font-size: 14px;color: #717B85;}
  .contract .info .item span{flex-shrink: 0;color:#717B85;background-color: #EFEFEF;padding:0px 10px;font-size:12px;font-weight:bold;height: 26px;border-radius:8px;display: flex;justify-content: center;align-items: center;}
  .contract .info .item p{font-size: 15px;color: #111111;margin-top: 4px;}
  .contract .info .item p a{color: #006FFF;}
  .contract .info .item .act{background-color:#DDE5FF;color:#1A48DD;}
  .contract .pdfArea{height: 100%;background-color: #EAEFF5;padding:20px 10px 0 10px;display: grid;grid-template-columns: 1fr;grid-template-rows: auto 1fr;}
  .contract .title{margin:0 10px 20px 10px;display: flex;justify-content: space-between;align-items: center;color: #111111;font-weight: bold;}
  .contract .title a{color: #4873FF;font-weight: normal;display: flex;align-items: center;}
  .contract .title a i{margin-right: 6px;}
  .contract .xyDiv{background-color: rgba(0, 0, 0, 0.5);position: fixed;left:0;top:0;width: 100vw;height: 100vh;z-index: 10;display: flex;align-items: flex-end;}
  .contract .xyDiv .content{background-color: #ffffff;padding:20px;border-radius: 16px 16px 0 0;display: grid;grid-template-columns: 1fr;width: 100%;}
  .contract .xyDiv .content .header{display: flex;justify-content:space-between;}
  .contract .xyDiv .content .header i{font-size: 20px;}
  .contract .xyDiv .content h1{margin:0;font-size: 20px;}
  .contract .xyDiv .content .pannel{background-color: #EAEFF5;border-radius: 12px;height: 255px;}
  .contract .xyDiv .title{margin:20px 0;}
  .contract .xyDiv .btnConfirm{background:#EBECF0;color:#A8A8BC;display: flex;bottom:20px;justify-content: center;align-items: center;width:100%;height: 52px;border-radius: 26px;font-weight: bold;}
  .contract .error{display: flex;margin-top:20px;margin-bottom:20px;align-items: center;color: #EC0000;font-size: 14px;justify-content: center;}
  .contract .error i{font-size: 18px;}
  .contract canvas{display: block;width: 100%;height: 100%;}
  >>> .vue-office-pdf-wrapper{background: transparent !important;padding:0 0 !important;height: 100% !important;}
  >>> .el-upload {width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 20px;}
  >>> .el-upload-dragger {width: 100%;height: 130px;}
  >>> .el-upload-dragger .el-icon-upload {font-size: 40px; margin: 10px 0 10px;}
</style>
